import gql from 'graphql-tag'

export const fragment = gql`
fragment generalSettings on AppConfig {
	name
	street
	postCode
	city
	countryId
	language
	mainCurrency
	isShopFieldActive
	technicalIssuesContacts
	cashRegisterGlobal {
		portosIntegrationKey
		e2nReportingActive
		e2nIntegrationActive
		isRevolutPaymentActive
		revolutPaymentDiscount
		isAxessVoucherSystemEnabled
		isGruberDispenserEnabled
	}
}`

const query = gql`
query getAppConfig {
	cashAssist {
		getAppConfig {
			...generalSettings
		}
	}
}
${fragment}`

export default query
